import React from "react";

const Upload = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M18 18.526l6.168 6.222-2.057 2.075-2.658-2.681v8.191h-2.907V24.14l-2.657 2.684-2.057-2.075L18 18.526zM18 3c2.496 0 4.904.926 6.768 2.6a10.298 10.298 0 013.34 6.485 7.997 7.997 0 014.458 3.173 8.121 8.121 0 01-.903 10.308 7.966 7.966 0 01-4.94 2.335L26.722 25a8.84 8.84 0 00-2.494-6.17 8.685 8.685 0 00-6.065-2.637 8.679 8.679 0 00-6.158 2.406 8.835 8.835 0 00-2.721 6.071l-.006.33v2.901a7.965 7.965 0 01-4.94-2.335 8.12 8.12 0 01-.904-10.308 7.997 7.997 0 014.457-3.173 10.297 10.297 0 013.34-6.485A10.124 10.124 0 0118 3z"
            fill={fill}
        />
    </svg>
);

export default Upload;
